'use client';

export { BattleCard } from './BattleCard';
export type { BattleData } from './BattleCard';
